export function mapCatalogServiceResponseToCategory(serviceResponse) {
    const { id, name, sortOrder } = serviceResponse.category;
    return {
        id,
        name,
        sortOrder,
    };
}
//# sourceMappingURL=category.mapper.js.map